"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useLayoutEffect } from "react";

import { WEBAPP_URL } from "@calcom/lib/constants";

export function NotFound({ host: _host }: { host: string }) {
  const pathname = usePathname() ?? "";
  const isBookingPage = pathname?.startsWith("/booking") || /^\/[^/]+\/[^/]+/.test(pathname);

  useLayoutEffect(() => {
    if (typeof window !== "undefined") {
      window.CalComPageStatus = "404";
    }
  }, []);

  return (
    <div className="bg-default min-h-screen px-4" data-testid="404-page">
      <main className="mx-auto max-w-lg pb-6 pt-24 text-center">
        <p className="text-subtle text-sm font-semibold uppercase tracking-widest">Error 404</p>
        <h1 className="font-cal text-emphasis mt-3 text-4xl font-extrabold sm:text-5xl">
          {isBookingPage ? "Booking page not available" : "Page not found"}
        </h1>
        <p className="text-subtle mt-4 text-base">
          {isBookingPage
            ? "This booking page is either hidden, no longer active, or the link may be incorrect."
            : "The page you're looking for doesn't exist or may have been moved."}
        </p>

        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Link
            href={WEBAPP_URL}
            className="bg-brand-default text-brand rounded-md px-5 py-2.5 text-sm font-semibold shadow-sm hover:opacity-90">
            Go to Schedly
          </Link>
          <button
            onClick={() => window.history.back()}
            className="border-subtle text-emphasis rounded-md border px-5 py-2.5 text-sm font-semibold hover:bg-gray-50">
            Go back
          </button>
        </div>

        {isBookingPage && (
          <p className="text-subtle mt-8 text-sm">
            Looking for a specific booking?{" "}
            <Link href={`${WEBAPP_URL}/auth/login`} className="text-emphasis underline underline-offset-2">
              Sign in to Schedly
            </Link>{" "}
            to manage your appointments.
          </p>
        )}
      </main>
    </div>
  );
}
